<div class="data-spinner" id="privacy-loader">
  <mat-spinner color="accent"></mat-spinner>
</div>

<prof-topnav-onetrust [title]="title"></prof-topnav-onetrust>
<!-- OneTrust Privacy Notice start -->

<!-- Language Drop-down elements that will control in which language notice is displayed -->
<div class="otnotice-language-dropdown-container">
  <select
    id="otnotice-language-dropdown"
    aria-label="language selector"
  ></select>
</div>

<!-- Container in which the privacy notice will be rendered -->
<div id="otnotice-d58e09fe-751b-4361-88a1-66a38c1f571d" class="otnotice"></div>

<!-- OneTrust Privacy Notice end -->

<!-- OneTrust Exercise Rights start -->

<a
  class="ot-btn-anchor"
  href="https://allegion-privacy.my.onetrust.com/webform/8b164882-ffc8-4155-8514-dc33976fd253/ae8fbc7d-6b5e-45f4-af18-93748981f17f"
>
  <button
    mat-stroked-button
    type="button"
    class="button-layout"
    color="primary"
  >
    <span class="ot-text-container">{{ 'ONETRUST.dsr' | translate }}</span>
  </button>
</a>

<!-- OneTrust Exercise Rights end -->
